import { IGetManifest, PaymentType, IPayByLinkData } from '@ace-clublabs/payment-types';
import { createGlobalState } from 'react-hooks-global-state';
import { Error, IConfirmationApiResponse } from './types';
import { IGetAdyenSession } from '../api/contracts';

type State = {
  error: Error | undefined;
  manifest: IGetManifest | undefined;
  redirectMap: { [manifestId: string]: string };
  renderAuthorization: boolean;
  scheduledDate: string | undefined;
  isScheduled: boolean | undefined;
  manifestId: string | undefined;
  paymentType?: PaymentType | undefined;
  isMobileApp: boolean;
  skipLanding: boolean;
  paymentMethodsSkipped?: boolean;
  sessionId?: string | undefined;
  AdyenSessionData?: IGetAdyenSession | undefined;
  emails?: {
    primaryEmail?: string | undefined;
    secondaryEmail?: string | undefined;
    isEmailOnFile?: boolean;
  };
  confirmationDetails: IConfirmationApiResponse[];
  payByLinkData?: IPayByLinkData;
  customerId?: string;
  epcRequestId?: string;
  paymentProcessing?: boolean;
  manifestTimestamp?: number;
};

const initialState = {
  error: undefined,
  manifest: undefined,
  redirectMap: {},
  renderAuthorization: false,
  scheduledDate: undefined,
  isScheduled: false,
  manifestId: undefined,
  paymentType: undefined,
  isMobileApp: false,
  skipLanding: false,
  paymentMethodsSkipped: false,
  sessionId: undefined,
  AdyenSessionData: undefined,
  emails: {
    primaryEmail: undefined,
    secondaryEmail: undefined,
    isEmailOnFile: false,
  },
  confirmationDetails: undefined,
  payByLinkData: undefined,
  customerId: '',
  epcRequestId: '',
  paymentProcessing: false,
  manifestTimestamp: undefined,
};

export const createInitialState = (): State => {
  const sessionStateString = sessionStorage.getItem('paymentsState') || '{}';
  const sessionState = JSON.parse(sessionStateString);
  const state = { ...initialState, ...sessionState };
  return state;
};

export const { useGlobalState } = createGlobalState<State>(createInitialState());
